import { TextField } from '@mui/material'
import React from 'react'
import { useRecoilValue } from 'recoil'
import useSavePatient from 'src/Patient/hooks/useSavePatient'
import { errorsFormRegisterState, valuesFormRegisterState } from 'src/Patient/state/atoms'
import InputLabelCustom from 'src/shared/components/forms/InputLabelCustom'

const NamesField = () => {
    const { handleChange } = useSavePatient();
    const { uswNombres } = useRecoilValue(valuesFormRegisterState);
    const { uswNombres: errorUswNombres } = useRecoilValue(errorsFormRegisterState);
    return (
        <>
            <InputLabelCustom htmlFor="input-nombres" text="Nombre(s) (*)" />
            <TextField
                id="input-nombres"
                size="small"
                error={errorUswNombres && errorUswNombres.length > 0 ? true : false}
                helperText={errorUswNombres && errorUswNombres.length > 0 ? `${errorUswNombres.join("\n")}` : ''}
                style={{ width: '100%' }}
                name="uswNombres"
                type="text"
                value={uswNombres || ""}
                InputLabelProps={{
                    shrink: true,
                }}
                variant="outlined"
                onChange={handleChange}
                autoComplete="off"
                placeholder='Ej: José Pedro'
            />
        </>
    )
}

export default NamesField
